export default "/images/phone-icon.svg?f6bdfd1c6d769459696fef0d48cf1068";